import React from 'react';
import Typed from 'react-typed';
import { useEffect } from 'react';

// import { Link } from 'react-router-dom';

function Azienda() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  /* const timeline_EN = [
    {
      year: '2017',
      description:
        'Electrical, Thermal, Mechanical modelling of Electric Motor & Inverter, Hybrid System Simulations',
      logo: 'https://upload.wikimedia.org/wikipedia/it/thumb/5/59/Logo_della_Scuderia_Ferrari_%28vecchio%29.svg/1200px-Logo_della_Scuderia_Ferrari_%28vecchio%29.svg.png',
      nomeCliente: 'Ferrari',
      subtitle: 'High performance hybrid vehicle',
    },
    {
      year: '2018',
      description: (
        <p>
          Project realized in partnership with 4e Consulting
          <br />
          Component specifications
          <br />
          Support in supplier relationship
          <br />
          System modeling and simulation
          <br />
          Development of whole software hybrid strategy and Vehicle Control Unit
          implementation
        </p>
      ),
      logo: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Logo_Carraro.png',
      nomeCliente: 'CARRARO - 4e Consulting',
      subtitle: `First Hybird Tractor in the world presented at EIMA 2018`,
    },
    {
      year: '2018',
      description: (
        <p>
          Project realized in partnership with 4e Consulting
          <br />
          Component specifications
          <br />
          Support in supplier relationship
          <br />
          System modeling and simulation
          <br />
          Development of whole software hybrid strategy and Vehicle Control Unit
          implementation
        </p>
      ),
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Manitou_Group_Logo.svg/1280px-Manitou_Group_Logo.svg.png',
      nomeCliente: 'MANITOU - 4e Consulting',
      subtitle: 'Hybrid Telehandler development presented at BAUMA 2019',
    },
    {
      year: '2019',
      description: (
        <p>
          Component specifications
          <br />
          Development of battery system and BMS
          <br />
          System modeling and simulation
          <br />
          Development of whole software hybrid strategy and Vehicle Control Unit
          implementation
        </p>
      ),
      logo: 'https://www.efestoenergy.com/wp-content/uploads/2019/10/EFESTOlogo.jpg',
      nomeCliente: 'Efesto',
      subtitle: 'Hybrid High-Performance Motorcycle',
    },
    {
      year: '2020',
      description: (
        <p>
          Development of the internal hybrid software strategy and
          implementation of the proprietary VCU
        </p>
      ),
      logo: 'https://www.scaipspa.com/wp-content/uploads/2018/08/LOGO_SCAIP_HR.png',
      nomeCliente: 'Scaip',
      subtitle: 'Development of a Hybrid Planter',
    },
    {
      year: '2021',
      description: `Platform control and energy storage system for the innovative Jet Deepspeed`,
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence',
      subtitle: '',
    },
    {
      year: '2022',
      description: ``,
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence Group',
      subtitle: 'Entry into the corporate Sealence Group',
    },
    {
      year: '2022',
      description: (
        <p>
          SAFEFLI Battery
          <br />
          SMARTBOX control system
          <br />
          REX180 Generator
          <br />
          <br />
          <span className="font-bold">Prototype boat outfitting</span>
        </p>
      ),
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      nomeCliente: 'Sealence Group',
      subtitle: 'Product realization for nautical field',
    },
    {
      year: '2022',
      description: 'Transition from Startup to Innovative SME',
      logo: '',
      nomeCliente: 'Innovative SME',
      subtitle: '',
    },
    {
      year: '2023',
      description:
        'Started the certification process at RINA and DNV certifying bodies',
      logo: '',
      nomeCliente: 'Certification and omologation Products',
      subtitle: '',
    },
  ]; 
  */

  const timeline_EN = [
    {
      year: '2017 - 2018',
      description: (
        <p>
          In 2017 we worked in the area of high-performance hybrid vehicles,
          creating electric, thermal, and mechanical models of electric motors
          and inverters. This work was further enhanced in 2018 with the
          presentation of the very first hybrid tractor at EIMA 2018. We
          provided component specifications, supported suppliers in their
          reports, created system models and simulations, and developed hybrid
          software strategies and vehicle control unit implementations for these
          vehicles.{' '}
        </p>
      ),
      // logo: 'https://upload.wikimedia.org/wikipedia/it/thumb/5/59/Logo_della_Scuderia_Ferrari_%28vecchio%29.svg/1200px-Logo_della_Scuderia_Ferrari_%28vecchio%29.svg.png',
      // nomeCliente: 'Ferrari',
      // subtitle: 'Veicolo ibrido ad alte prestazioni',
    },
    {
      year: '2019 - 2020',
      description: (
        <p>
          In the second part of 2019, we further expanded our horizons with the
          development of a hybrid telehandler presented at BAUMA 2019. Again, we
          provided component specifications, supported suppliers in their
          reports, created system models and simulations, and developed hybrid
          software strategies and vehicle control unit implementations. Finally,
          our work focused on the development of a high-performance hybrid
          motorcycle, for which we provided battery and battery management
          system specifications, system models and simulations, and developed
          hybrid software strategies and vehicle control unit implementations.
          <br />
          <br />
          Overall, our work in hybrid vehicles has been groundbreaking, and we
          are proud to say that we have been at the forefront of this
          technology, creating reliable and efficient systems for some of the
          world's most remarkable vehicles.
        </p>
      ),
      // logo: 'https://upload.wikimedia.org/wikipedia/commons/3/37/Logo_Carraro.png',
      // nomeCliente: 'CARRARO - 4e Consulting',
      // subtitle: `Primo trattore ibrido al mondo presentato all'EIMA 2018`,
    },
    {
      year: '2021',
      description: (
        <p>
          The year 2021 was a year of big changes for eDriveLAB, with the new
          collaboration with Sealence enabled a change in business model from
          system integrator to product company.
          <br />
          <br />
          We developed a series of products dedicated to the boating world in
          collaboration with SEALENCE Spa, including a marinized lithium
          battery, a range extender, and all the systems control logic of the
          Innovative Jet Deepspeed.
        </p>
      ),
      logo: 'https://www.sealence.it/wp-content/uploads/2020/10/sealence-reg.png',
      // nomeCliente: 'MANITOU - 4e Consulting',
      // subtitle: 'Sviluppo di un telehandler ibrido presentato a BAUMA 2019',
    },
    {
      year: '2022',
      description: (
        <p>
          In 2022 we carried out major field tests to verify the effectiveness
          of our products and their reliability, combining all the know-how
          acquired in previous years. In the same year, we reached the milestone
          of an Innovative SME.
        </p>
      ),
      // logo: 'https://www.efestoenergy.com/wp-content/uploads/2019/10/EFESTOlogo.jpg',
      // nomeCliente: 'Efesto',
      // subtitle: 'Moto ibrida ad alte prestazioni',
    },
    {
      year: '2023',
      description: (
        <p>
          In 2023, the company will begin the process of certification with
          bodies such as RINA and DNV, guaranteeing the safety and quality of
          its products. eDriveLAB is committed to providing its customers with
          the highest quality products and services and to continuing its
          efforts in innovation and development.
        </p>
      ),
      // logo: 'https://www.scaipspa.com/wp-content/uploads/2018/08/LOGO_SCAIP_HR.png',
      // nomeCliente: 'Scaip',
      // subtitle: 'Sviluppo di un Piantapali Ibrido',
    },
  ];

  return (
    <>
      <section className="container px-10 pt-16 mx-auto">
        <div className="text-center">
          <p className="text-3xl font-bold md:text-4xl">
            <span className="text-5xl text-blue-600">
              <Typed
                strings={['To Innovate', 'To Grow', 'To Design', 'To Develop']}
                typeSpeed={75}
                startDelay={25}
                backDelay={1500}
                backSpeed={25}
                loop
              />
            </span>
            <br />
            is what inspire our company
          </p>
          <p className="mt-4">
            A vision of global growth through the evolution of technologies and
            products in the field of sustainable mobility.
          </p>
        </div>
      </section>
      <section className="container flex flex-col gap-8 mx-auto mt-8 mb-16 lg:flex-row lg:gap-0">
        <div className="flex-1 p-8 mx-8 border border-green-700 rounded-lg">
          <div className="text-center">
            <span className="text-2xl font-bold text-green-700">
              Our Mission
            </span>

            <p className="mt-4">
              DriveLAB srl is an Innovative SME, a spin-off of the University of
              Parma, which was founded in 2017 by the partners' desire to apply
              their expertise in the field of power electronics. Since its
              establishment, it has based its activity toward engineering
              consulting services related to design and development of
              electrified vehicles of an innovative nature.
            </p>
          </div>
        </div>
        {/* <div className="flex-1 p-8 mx-8 border border-blue-700 rounded-lg">
          <div className="text-center">
            <span className="font-bold text-blue-700">Vision</span>
            <h3 className="text-2xl font-bold">
              Rendere possibile la mobilità sostenibile
            </h3>
            <p className="mt-4">
              La nostra vision è quella di avviare attività di ricerca sia con
              aziende private che con partner pubblici (nazionali, europei e
              mondiali), portando sul mercato le innovazioni sviluppate negli
              anni.
            </p>
          </div>
        </div> */}
        <div className="flex-1 p-8 mx-8 border border-red-700 rounded-lg">
          <div className="text-center">
            <span className="text-2xl font-bold text-red-700">Our Purpose</span>

            <p className="mt-4">
              eDriveLAB is aiming to expand its production capacity by bringing
              its products to market, on the strength of an ever-growing network
              of customers who come into contact with the company and who
              demonstrate a strong demand for the supply of electrified vehicle
              products needed to follow the strong trend of transition to more
              sustainable technologies.
            </p>
          </div>
        </div>
      </section>
      <section className="mx-auto">
        <div className="flex flex-col items-center justify-start w-full px-8 py-10 bg-slate-100">
          <span className="mb-10 text-4xl font-bold text-center">Timeline</span>
          {timeline_EN.map((event, id) => (
            <div className="flex flex-col items-center">
              <div className="max-w-2xl p-10 mx-auto bg-white border-2 border-blue-500 rounded-lg">
                <div className="flex flex-col items-center gap-8 md:flex-row">
                  <div className="">
                    <img src={event.logo} alt="" className="max-w-[100px]" />
                  </div>
                  <div>
                    <div className="flex items-center justify-start gap-2">
                      <span className="px-4 py-2 text-lg font-bold text-blue-700 rounded-lg bg-blue-500/25">
                        {event.year}
                      </span>
                      {/* <span className="text-xl font-bold text-blue-700">–</span> */}
                      <span className="py-2 text-xl font-bold text-blue-700">
                        {event.nomeCliente}
                      </span>
                    </div>
                    <p className="mt-4 font-bold">{event.subtitle}</p>
                    <p className="mt-4">{event.description}</p>
                  </div>
                </div>
              </div>
              {id + 1 !== timeline_EN.length ? (
                <div className="w-0.5 h-20 bg-blue-500"></div>
              ) : (
                ''
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Azienda;
